import React from 'react';
import { wrap } from './style';

function Background({
  children,
  onClick,
}: React.PropsWithChildren<{
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}>) {
  return (
    <div css={wrap} onClick={onClick}>
      {children}
    </div>
  );
}

export default Background;
